module.exports = __webpack_public_path__ + "static/media/huli_403.625a559a.gif";